import { defineComponent, computed, createElementBlock, openBlock, createVNode, withCtx, createElementVNode, createCommentVNode, normalizeClass, createTextVNode, toDisplayString, Fragment, renderList, createBlock, mergeProps, renderSlot } from 'vue';
import _sfc_main$3 from './basler-components.es240.js';
/* empty css                        */
import _sfc_main$1 from './basler-components.es95.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es73.js';
/* empty css                       */

const _hoisted_1 = { class: "products-list-table" };
const _hoisted_2 = { class: "products-list-table__table" };
const _hoisted_3 = ["aria-sort"];
const _hoisted_4 = ["aria-sort"];
const _hoisted_5 = ["aria-sort"];
const _hoisted_6 = ["aria-sort"];
const _hoisted_7 = ["aria-sort"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductListTable",
  props: {
    items: {},
    defaultColumns: {},
    attributeColumns: {}
  },
  emits: ["sort"],
  setup(__props) {
    const props = __props;
    const media = computed(() => {
      return props.defaultColumns.find((item) => item.key === "media");
    });
    const title = computed(() => {
      return props.defaultColumns.find((item) => item.key === "title");
    });
    const description = computed(() => {
      return props.defaultColumns.find((item) => item.key === "description");
    });
    const priceText = computed(() => {
      return props.defaultColumns.find((item) => item.key === "priceText");
    });
    const getFullSortingDirectionName = (direction) => {
      switch (direction) {
        case "asc":
          return "ascending";
        case "desc":
          return "descending";
        case "other":
          return "other";
        default:
          return void 0;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_sfc_main$1, null, {
          default: withCtx(() => [
            createElementVNode("table", _hoisted_2, [
              createElementVNode("thead", null, [
                createElementVNode("tr", null, [
                  media.value ? (openBlock(), createElementBlock("th", {
                    key: 0,
                    class: normalizeClass(`products-list-table_th-${media.value.key}`),
                    "aria-sort": getFullSortingDirectionName(media.value.sortingDirection)
                  }, [
                    createVNode(_sfc_main$2, {
                      "is-sortable": media.value.isSortable,
                      "sorting-direction": media.value.sortingDirection,
                      "hide-columnLabel": media.value.hideColumnLabel,
                      onClick: _cache[0] || (_cache[0] = ($event) => media.value.isSortable ? _ctx.$emit("sort", media.value.key) : void 0)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(media.value.columnLabel), 1)
                      ]),
                      _: 1
                    }, 8, ["is-sortable", "sorting-direction", "hide-columnLabel"])
                  ], 10, _hoisted_3)) : createCommentVNode("", true),
                  title.value ? (openBlock(), createElementBlock("th", {
                    key: 1,
                    class: normalizeClass(`products-list-table_th-${title.value.key}`),
                    "aria-sort": getFullSortingDirectionName(title.value.sortingDirection)
                  }, [
                    createVNode(_sfc_main$2, {
                      "is-sortable": title.value.isSortable,
                      "sorting-direction": title.value.sortingDirection,
                      "hide-columnLabel": title.value.hideColumnLabel,
                      onClick: _cache[1] || (_cache[1] = ($event) => title.value.isSortable ? _ctx.$emit("sort", title.value.key) : void 0)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(title.value.columnLabel), 1)
                      ]),
                      _: 1
                    }, 8, ["is-sortable", "sorting-direction", "hide-columnLabel"])
                  ], 10, _hoisted_4)) : createCommentVNode("", true),
                  description.value ? (openBlock(), createElementBlock("th", {
                    key: 2,
                    class: normalizeClass(`products-list-table_th-${description.value.key}`),
                    "aria-sort": getFullSortingDirectionName(description.value.sortingDirection)
                  }, [
                    createVNode(_sfc_main$2, {
                      "is-sortable": description.value.isSortable,
                      "sorting-direction": description.value.sortingDirection,
                      "hide-columnLabel": description.value.hideColumnLabel,
                      onClick: _cache[2] || (_cache[2] = ($event) => description.value.isSortable ? _ctx.$emit("sort", description.value.key) : void 0)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(description.value.columnLabel), 1)
                      ]),
                      _: 1
                    }, 8, ["is-sortable", "sorting-direction", "hide-columnLabel"])
                  ], 10, _hoisted_5)) : createCommentVNode("", true),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.attributeColumns, (attributeColumn) => {
                    return openBlock(), createElementBlock("th", {
                      key: attributeColumn.key,
                      "aria-sort": getFullSortingDirectionName(attributeColumn.sortingDirection)
                    }, [
                      createVNode(_sfc_main$2, {
                        "is-sortable": attributeColumn.isSortable,
                        "sorting-direction": attributeColumn.sortingDirection,
                        onClick: ($event) => attributeColumn.isSortable ? _ctx.$emit("sort", attributeColumn.key) : void 0
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(attributeColumn.columnLabel), 1)
                        ]),
                        _: 2
                      }, 1032, ["is-sortable", "sorting-direction", "onClick"])
                    ], 8, _hoisted_6);
                  }), 128)),
                  priceText.value ? (openBlock(), createElementBlock("th", {
                    key: 3,
                    "aria-sort": getFullSortingDirectionName(priceText.value.sortingDirection)
                  }, [
                    createVNode(_sfc_main$2, {
                      "is-sortable": priceText.value.isSortable,
                      "sorting-direction": priceText.value.sortingDirection,
                      "hide-columnLabel": priceText.value.hideColumnLabel,
                      onClick: _cache[3] || (_cache[3] = ($event) => priceText.value.isSortable ? _ctx.$emit("sort", priceText.value.key) : void 0)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(priceText.value.columnLabel), 1)
                      ]),
                      _: 1
                    }, 8, ["is-sortable", "sorting-direction", "hide-columnLabel"])
                  ], 8, _hoisted_7)) : createCommentVNode("", true)
                ])
              ]),
              createElementVNode("tbody", null, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
                  return openBlock(), createBlock(_sfc_main$3, mergeProps({
                    key: `${index}-${item.product.id}`,
                    ref_for: true
                  }, item), {
                    "item-cta": withCtx(() => [
                      renderSlot(_ctx.$slots, "card-footer", mergeProps({ ref_for: true }, item))
                    ]),
                    _: 2
                  }, 1040);
                }), 128))
              ])
            ])
          ]),
          _: 3
        })
      ]);
    };
  }
});

export { _sfc_main as default };
